import { IFieldType, IFormFields } from "shared/types";
import { copy } from "shared/assets";
import { eventStatuses } from "Bands/utils";
import { IEvent, IEventStatus, IIconBandSetting } from "Bands/types";
import { getIcon, DateFormat, TimeFormat } from "shared/utils";
import { ToolbarItems } from "shared/components/Form/Fields/RTE/components";

const { errors, actions } = copy;
const eventProperties = copy.event.properties;

export const getFields = ({
  eventTypes,
  manageEventTypes,
  timeFormat,
  canManageTypes = false,
  placeholder,
  updatePlaceholder,
  setTime,
  setDate,
  ...datePickerProps
}: {
  eventTypes: IIconBandSetting[];
  manageEventTypes: () => void;
  timeFormat?: TimeFormat;
  dateFormat?: DateFormat;
  canManageTypes?: boolean;
  placeholder: Partial<IEvent>;
  updatePlaceholder: (event: Partial<IEvent>) => void;
  setTime?: (v: string) => void;
  setDate?: (v: string) => void;
}): IFormFields => [
  {
    type: IFieldType.text,
    name: "title",
    label: eventProperties.title.title,
    validation: {
      required: errors.required,
    },
    style: { gridColumn: "1/4" },
    onChange: ({ target: { value: title } }) => {
      updatePlaceholder({ ...placeholder, title });
    },
  },
  {
    type: IFieldType.datePicker,
    name: "date",
    label: eventProperties.date.title,
    validation: {
      required: errors.required,
    },
    style: { mobile: { gridColumn: "1/4" } },
    ...datePickerProps,
    onChange: (date: string) => {
      date && updatePlaceholder({ ...placeholder, date });
      setDate && setDate(date);
    },
  },
  {
    type: IFieldType.simpleTime,
    name: "time",
    label: eventProperties.startTime.title,
    timeFormat,
    onChange: (time: string) => setTime && setTime(time),
    style: { mobile: { gridColumn: "1/4" } },
  },
  {
    name: "timeZone",
    label: eventProperties.timeZone.title,
    type: IFieldType.timezone,
    validation: {
      required: errors.required,
    },
    style: { mobile: { gridColumn: "1/4" } },
  },
  {
    name: "type",
    label: eventProperties.type.title,
    type: IFieldType.tagGroup,
    style: { gridColumn: "1/4" },
    options: eventTypes?.map(({ icon, id, ...props }) => ({
      ...props,
      value: id,
      icon: getIcon(icon),
    })),
    validation: {
      required: errors.required,
    },
    onChange: (type: string) => {
      type && updatePlaceholder({ ...placeholder, type });
    },
    ...(canManageTypes && {
      fieldLink: {
        label: actions.manage,
        onClick: manageEventTypes,
      },
    }),
  },
  {
    name: "status",
    label: eventProperties.status.title,
    type: IFieldType.tagGroup,
    style: { gridColumn: "1/4" },
    options: eventStatuses,
    validation: {
      required: errors.required,
    },
    onChange: (status: IEventStatus) => {
      status && updatePlaceholder({ ...placeholder, status });
    },
  },
  {
    type: IFieldType.rte,
    name: "description",
    label: eventProperties.description.title,
    excludeItems: { [ToolbarItems.list]: true },
    style: { gridColumn: "1/4" },
    onChange: (description: string) => {
      updatePlaceholder({ ...placeholder, description });
    },
  },
];
